import { useEffect, useState } from 'react';

function useUserLocation() {
  const [userLocation, setUserLocation] = useState(null);
  const [userLocationAccuracy, setUserLocationAccuracy] = useState(null);
  const [userLocationError, setUserLocationError] = useState(null);
  const [locationPermission, setLocationPermission] = useState('unknown');

  useEffect(() => {
    if (!navigator.geolocation) {
      setUserLocationError('Geolocalización no disponible');
      return;
    }

    let watchId = null;
    let permissionStatus = null;

    const iniciarSeguimiento = () => {
      if (watchId !== null) return;

      watchId = navigator.geolocation.watchPosition(
        position => {
          const latitude = Number(position.coords.latitude);
          const longitude = Number(position.coords.longitude);
          const accuracy = Number(position.coords.accuracy);

          if (
            Number.isNaN(latitude) ||
            Number.isNaN(longitude)
          ) {
            return;
          }

          setUserLocation({
            lat: latitude,
            lng: longitude
          });

          setUserLocationAccuracy(
            Number.isNaN(accuracy) ? null : accuracy
          );

          setUserLocationError(null);
        },
        error => {
          setUserLocationError(
            error?.message || 'Ubicación no disponible'
          );
        },
        {
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 10000
        }
      );
    };

    const verificarPermiso = async () => {
      if (
        !navigator.permissions ||
        !navigator.permissions.query
      ) {
        iniciarSeguimiento();
        return;
      }

      try {
        permissionStatus = await navigator.permissions.query({
          name: 'geolocation'
        });

        setLocationPermission(permissionStatus.state);

        if (
          permissionStatus.state === 'granted' ||
          permissionStatus.state === 'prompt'
        ) {
          iniciarSeguimiento();
        }

        permissionStatus.onchange = () => {
          setLocationPermission(permissionStatus.state);

          if (permissionStatus.state === 'granted') {
            iniciarSeguimiento();
          }
        };
      } catch (error) {
        iniciarSeguimiento();
      }
    };

    verificarPermiso();

    return () => {
      if (watchId !== null) {
        navigator.geolocation.clearWatch(watchId);
      }

      if (permissionStatus) {
        permissionStatus.onchange = null;
      }
    };
  }, []);

  return {
    userLocation,
    userLocationAccuracy,
    userLocationError,
    locationPermission
  };
}

export default useUserLocation;